(function () {
  function mountBannerNineContent() {
    var slide = document.querySelector('#shopify-section-home #anHero.hero .hero-slide:nth-child(9)');
    if (!slide) return;

    var fullLink = slide.querySelector('.hero-link');
    if (fullLink) {
      fullLink.href = '/pages/scent-profiling';
      fullLink.setAttribute('aria-label', 'Take the scent quiz');
    }

    if (slide.querySelector('.an-hero-copy-layer--profiling')) return;

    var scrim = document.createElement('div');
    scrim.className = 'an-hero-copy-scrim an-hero-copy-scrim--profiling';
    scrim.setAttribute('aria-hidden', 'true');

    var layer = document.createElement('div');
    layer.className = 'an-hero-copy-layer an-hero-copy-layer--profiling';
    layer.innerHTML = [
      '<div class="an-hero-copy an-hero-copy--profiling">',
      '<div class="an-hero-profiling-text">',
      '<h2 aria-label="Find Your Signature Scent">',
      '<span class="an-hero-profiling-line">Find Your</span>',
      '<span class="an-hero-profiling-line">Signature <span class="an-hero-profiling-accent">Scent.</span></span>',
      '</h2>',
      '<p>Not sure what to wear? Take our quick quiz and discover fragrances you’ll love.</p>',
      '</div>',
      '<a class="an-hero-cta an-hero-cta--profiling" href="/pages/scent-profiling">Take The Quiz →</a>',
      '</div>'
    ].join('');

    slide.appendChild(scrim);
    slide.appendChild(layer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBannerNineContent);
  } else {
    mountBannerNineContent();
  }

  window.addEventListener('pageshow', mountBannerNineContent);
  document.addEventListener('shopify:section:load', mountBannerNineContent);
})();
